import { useState, useCallback, useEffect } from "react";
import {
	TextField,
	InputAdornment,
	Accordion,
	AccordionSummary,
	AccordionDetails,
	Checkbox,
	withStyles,
	ListItemIcon,
	ListItem,
	Divider,
	List,
	ListItemText,
	CheckboxProps,
	Breadcrumbs,
	Link
} from "@material-ui/core";
import { green } from "@material-ui/core/colors";
import { useDebouncedCallback } from "use-debounce";
import { TreeViewProps } from "../../../../../@types/components/assignGroupsProps.types";
import { GroupsAndLocations, LocationSchema } from "../../../../../@types/group.types";

import SearchIcon from "@material-ui/icons/Search";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";

import "./treeView.css";
import { useEmployerRoute } from "../../../../../hooks";
import useRouteParam from "../../../../../hooks/useRouteParam";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";

const TreeView = (props: TreeViewProps) => {
	const [filteredGroups, setFilteredGroups] = useState<GroupsAndLocations[]>([]);
	const isEmployerRoute = useEmployerRoute();
	const [groups, setGroups] = useState<any[]>([]);

	const [isSelectAllLocations, setIsSelectAllLocations] = useState<any>({});
	const navigate = useNavigate();
	const queryGroupNumber = useRouteParam("gn");
	const {
		handleAssignGroup,
		handleAssignLocation,
		handleSaveAllGroups,
		handleSaveAllLocations,
		assignmentStatus,
		handleSelectProfile,
		employer,
		handleAssignSelectedLocationsToTheGroups,
		handleSelectAllLocationsClick
	} = props;

	const DarkCheckbox = withStyles({
		root: {
			color: "#757575",
			"&$checked": {
				color: "#757575"
			}
		},
		checked: {}
	})((props: CheckboxProps) => <Checkbox color="default" {...props} />);

	const GreenCheckbox = withStyles({
		root: {
			color: green[400],
			"&$checked": {
				color: green[600]
			}
		},
		checked: {}
	})((props: CheckboxProps) => <Checkbox color="default" {...props} />);

	const filterGroups = useDebouncedCallback(
		useCallback(
			(searchQuery: string) => {
				const _filteredGroups: GroupsAndLocations[] = [];

				groups.forEach((group: GroupsAndLocations) => {
					const { name } = group;
					if (name && name.toLowerCase().indexOf(searchQuery) !== -1) {
						_filteredGroups.push(group);
					}
				});

				setFilteredGroups(Object.assign([], _filteredGroups));
			},
			[groups]
		),
		500
	);

	const handleSearchChange = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) => {
			const { value } = event.target;
			const searchQuery = value.toLowerCase();
			filterGroups(searchQuery);
		},
		[filterGroups]
	);

	const handleBreadcrumClick = useCallback(() => {
		let pathname;
		if (isEmployerRoute === true && queryGroupNumber !== null) {
			pathname = `/employer/settings/user-management?gn=${queryGroupNumber}`;
		} else {
			pathname = "/settings/user-management";
		}

		navigate(pathname);
	}, [isEmployerRoute, navigate, queryGroupNumber]);

	useEffect(() => {
		if (isEmployerRoute !== null && queryGroupNumber !== undefined && employer !== undefined) {
			if (isEmployerRoute === true && queryGroupNumber !== null) {
				const _groups: GroupsAndLocations[] = [];
				props.groups.forEach((_group: GroupsAndLocations) => {
					const { group_number } = _group;
					if (group_number === Number(queryGroupNumber)) {
						_groups.push(_group);
					}
				});
				setGroups(Object.assign([], _groups));
				setFilteredGroups(Object.assign([], _groups));
			} else {
				if (employer !== null) {
					// console.log("isEmployerRoute", isEmployerRoute);
					// console.log("queryGn", queryGroupNumber);
					// console.log("employer", employer);
					const _groups: GroupsAndLocations[] = [];
					props.groups.forEach((_group: GroupsAndLocations) => {
						const { group_number } = _group;
						if (group_number === employer.group_number) {
							_groups.push(_group);
						}
					});
					setGroups(Object.assign([], _groups));
					setFilteredGroups(Object.assign([], _groups));
				} else {
					// console.log("isEmployerRoute", isEmployerRoute);
					// console.log("queryGn", queryGroupNumber);
					// console.log("employer", employer);
					setGroups(Object.assign([], props.groups));
					setFilteredGroups(Object.assign([], props.groups));
				}
			}
		}
	}, [employer, isEmployerRoute, props.groups, queryGroupNumber]);

	// console.log("groups", groups);

	useEffect(() => {
		if (groups && groups.length > 0) {
			groups.forEach((group: any) => {
				if (group && Object.keys(group).length > 0) {
					const group_number = group.group_number;
					// const { _id, unassigned_locations, assigned_locations, group_number } = group;
					let allSelected = true;
					if (group["all_locations"] && Object.keys(group["all_locations"]).length > 0) {
						Object.keys(group["all_locations"]).forEach((_id: any) => {
							allSelected = allSelected && group["all_locations"][_id][0];
						});
					}
					setIsSelectAllLocations((prev: any) => {
						return { ...prev, [group_number]: allSelected };
					});
				}
			});

			// console.log(groups, isSelectAllLocations);
		}
	}, [groups]);

	return (
		<div className="tree-view">
			<div className="breadcrum-text-container" id="breadcrum-text">
				<Breadcrumbs
					separator={<NavigateNextIcon fontSize="small" style={{ color: "#e0e0e0" }} />}
					aria-label="breadcrumb"
				>
					<Link className="breadcrumb-link-text" onClick={handleBreadcrumClick}>
						User Management
					</Link>
					<span className="breadcrumb-text">Assign Groups</span>
				</Breadcrumbs>
			</div>
			<div>
				<TextField
					id="search-groups"
					placeholder="Search Groups"
					variant="outlined"
					fullWidth
					InputProps={{
						startAdornment: (
							<InputAdornment position="start">
								<SearchIcon style={{ color: "#7cb342" }} />
							</InputAdornment>
						)
					}}
					onChange={handleSearchChange}
				/>
			</div>
			{employer === null ? (
				<div className="select-actions-container">
					<div className="flex-item-start">
						<DarkCheckbox onChange={handleSaveAllGroups} checked={assignmentStatus.all_groups} />
						All Groups
						<DarkCheckbox onChange={handleSaveAllLocations} checked={assignmentStatus.all_locations} />
						All Locations
					</div>
					<div className="flex-item-end">
						<Button
							style={{ backgroundColor: "#757575", color: "white" }}
							onClick={handleAssignSelectedLocationsToTheGroups}
						>
							{" "}
							Save
						</Button>
					</div>
				</div>
			) : (
				<div className="select-actions-container">
					<div className="flex-item-end">
						<Button
							style={{ backgroundColor: "#757575", color: "white" }}
							onClick={handleAssignSelectedLocationsToTheGroups}
						>
							{" "}
							Save
						</Button>
					</div>
				</div>
			)}
			<Divider className="actions-divider" />
			<div className="items">
				{filteredGroups.length !== 0 ? (
					filteredGroups.map((group: GroupsAndLocations) => {
						const { _id, name, assigned_locations, unassigned_locations, all_locations } = group;

						return (
							<Accordion key={_id}>
								<AccordionSummary
									expandIcon={<ExpandMoreIcon />}
									className="accordion-summary-container"
								>
									<div className="accordion-summary">
										<span
											onClick={(event: React.MouseEvent<HTMLSpanElement>) =>
												event.stopPropagation()
											}
											style={{
												cursor: employer ? "not-allowed" : "inherit"
											}}
										>
											<GreenCheckbox
												checked={group["group_assigned"]}
												className="select-group-icon"
												onChange={() => {
													handleAssignGroup(group);
												}}
												// disabled={employer ? true : false}
											/>
										</span>
										<span
											className="group-name"
											onClick={(event: React.MouseEvent<HTMLSpanElement>) => {
												event.stopPropagation();
												handleSelectProfile(group, "group");
											}}
											onFocus={(event: React.FocusEvent<HTMLSpanElement>) =>
												event.stopPropagation()
											}
										>
											{name}
										</span>
									</div>
								</AccordionSummary>
								<AccordionDetails>
									<List className="location-list">
										<ListItem key={_id + "group"}>
											<ListItemIcon onClick={() => handleSelectAllLocationsClick(group)}>
												<GreenCheckbox
													className="select-group-icon"
													checked={isSelectAllLocations[group.group_number]}
												/>
											</ListItemIcon>
											<ListItemText
												className="list-location-text"
												primary={"Select All Locations"}
												onClick={() => handleSelectProfile(group, "group")}
											/>
										</ListItem>
										{all_locations &&
											Object.keys(all_locations).length !== 0 &&
											Object.keys(all_locations).map((id: any) => {
												// console.log("all_locations", all_locations);
												// const { _id, location_number, location_name } = location;
												return (
													<ListItem key={id}>
														<ListItemIcon
															onClick={() =>
																handleAssignLocation(
																	group._id,
																	id,
																	!all_locations[id][0]
																)
															}
														>
															<GreenCheckbox
																className="select-group-icon"
																checked={all_locations[id][0]}
															/>
														</ListItemIcon>
														<ListItemText
															className="list-location-text"
															primary={`${all_locations[id][1]} - ${all_locations[id][2]}`}
															onClick={() => handleSelectProfile(group, "group")}
														/>
													</ListItem>
												);
											})}
										{/* {unassigned_locations.length !== 0 &&
											unassigned_locations.map((location: LocationSchema) => {
												const { _id, location_number, location_name } = location;
												return (
													<ListItem key={_id}>
														<ListItemIcon
															onClick={() => handleAssignLocation(location, true)}
														>
															<GreenCheckbox
																className="select-group-icon"
																checked={false}
															/>
														</ListItemIcon>
														<ListItemText
															className="list-location-text"
															primary={`${location_number} - ${location_name}`}
															onClick={() => handleSelectProfile(group, "group")}
														/>
													</ListItem>
												);
											})} */}
									</List>
								</AccordionDetails>
							</Accordion>
						);
					})
				) : (
					<div className="no-result">No such groups found!</div>
				)}
			</div>
		</div>
	);
};

export default TreeView;
